import requestAnimationFrame from 'requestanimationframe'
import DistributeHeight from './DistributeHeight'

const distributeHeight = new DistributeHeight()

export default class {

  constructor (functionGuide) {
    this.functionGuide = functionGuide
    this.windowWidth = $(window).width()
  }

  resize () {
    let calculate,
      tick,
      ticking = false

    calculate = () => {
      distributeHeight.setHeights()
      this.functionGuide.setHeight()
      this.functionGuide.movePanels()

      if (this.windowWidth != $(window).width()) {
        this.functionGuide.closeAllPanelsOnMobile()
      }
      ticking = false
    }

    tick = function () {
      if (!ticking) {
        requestAnimationFrame(calculate)
        ticking = true
      }
    }
    tick()

    $(window).on('load resize', function () {
      tick()
    })
  }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Utilities/Resize.js